import MetricGraph from "./Graph";

const MetricTab = ({ metrics, patient }) => {
  return <MetricGraph metrics={metrics} patient={patient} />;
};

export default MetricTab;
